"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCalculatorFields = void 0;
var _reactUtils = require("@cian/react-utils");
var _react = require("react");
var _useInitialValues = require("./useInitialValues");
const useCalculatorFields = () => {
  const initialValues = (0, _useInitialValues.useInitialValues)();
  const {
    initialPrice,
    initialPeriod,
    withEscrow
  } = initialValues;
  const [price, setPrice] = (0, _react.useState)(initialPrice);
  const [initialPayment, setInitialPayment] = (0, _react.useState)(initialValues.initialPayment);
  const [paymentPeriod, setPaymentPeriod] = (0, _react.useState)(initialPeriod);
  const {
    state: showEscrow,
    toggle: toggleShowEscrow
  } = (0, _reactUtils.useToggleState)(!!withEscrow);
  const initialPaymentPercent = (0, _react.useMemo)(() => Math.min(100, Math.floor(initialPayment / price * 100)), [initialPayment, price]);
  const {
    minPrice,
    maxPrice
  } = (0, _react.useMemo)(() => {
    const minPrice = Math.min(1e5, initialPrice);
    const maxPrice = Math.max(5e7, initialPrice);
    return {
      minPrice,
      maxPrice
    };
  }, [initialPrice]);
  return (0, _react.useMemo)(() => ({
    price,
    initialPayment,
    paymentPeriod,
    initialPaymentPercent,
    maxPrice,
    minPrice,
    showEscrow,
    onShowEscrowToggle: toggleShowEscrow,
    onPriceChange: setPrice,
    onInitialPaymentChange: setInitialPayment,
    onPaymentPeriodChange: setPaymentPeriod
  }), [initialPayment, initialPaymentPercent, maxPrice, minPrice, paymentPeriod, price, showEscrow, toggleShowEscrow]);
};
exports.useCalculatorFields = useCalculatorFields;